import { APIService } from '../services/index'

const initState = {
    loading: false,
    textProcess: 'In processo...',
    listaNote: [],
    speseMensile: [],
    spesaDettaglio: {},
    preautorizzati:[],
    categorie:[],
    richieste:[],
    allUsers:[],
}

const pageStore = {
    state: initState,
    namespaced: true,
    getters: {
        loading(state) {
            return state.loading
        },
        textProcess(state) {
            return state.textProcess
        },
        note(state) {
            return state.listaNote
        },
        preautorizzati(state) {
            return state.preautorizzati
        },
        categorie(state) {
            return state.categorie
        },
        richieste(state) {
            return state.richieste
        },
        allUsers(state) {
            return state.allUsers
        },
        richiestePerConfermare(state) {
            return state.richieste.filter(r => r.stato == 0)
        },
        notePerData(state) {
            return (login, data) => {
                return state.listaNote
                            .filter(ln => ln.login === login)
                            .shift()
                            .spese
                            .filter(it => it.data === data)
                            .shift()
            }
        },
        spesaDettaglio(state) {
            return state.spesaDettaglio
        },
    },
    mutations: {
        SET_LOADING(state, payload) {
            state.loading = payload.state;
            state.textProcess = payload.text || initState.textProcess;
        },
        SET_NOTE(state, payload) {
            state.listaNote = payload;
        },
        SET_REPORT_MENSILE(state, payload) {
            state.speseMensile = payload;
        },
        SET_SPESA_DETTAGLIO(state, payload) {
            state.spesaDettaglio = payload;
        },
        SET_PREAUTORIZZATI(state, payload) {
            state.preautorizzati = payload;
        },
        SET_CATEGORIE(state, payload) {
            state.preautorizzati = payload;
        },
        SET_RICHIESTE(state, payload) {
            state.richieste = payload;
        },
        SET_ALLUSERS(state, payload) {
            state.allUsers = payload;
        },
    },
    actions: {
        getNote(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            APIService.AdminGetioneGetNoteDaVerificare()
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.commit('SET_NOTE', res.data)
                        }
                    })
        },
        getAllUsers(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            APIService.getAllUsers()
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.commit('SET_ALLUSERS', res.data.utenti)
                        }
                    })
        },
        getDettaglioSpesa(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            APIService.AdminGetioneGetDettaglioSpesa(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.commit('SET_SPESA_DETTAGLIO', res.data)
                        }
                    })
        },
        confirmNota(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'Processing...'});
            return APIService.AdminGestioneConfirmNotaSpesa(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.dispatch('getNote');
                            return true
                        }
                        return false
                    })
        },
        protocollaSpesa(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'Generazione PDF...'});
            return APIService.AdminGetioneProtocollaSpesa(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        return res
                    })
        },
        confermaProtocolloSpesa(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'Confermazione...'});
            return APIService.AdminGetioneConfermaProtocolloSpesa(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        context.dispatch('getNote');
                        return res
                    })
        },
        inviaSpesa(context, params) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'Sta inviando ...'});
            return APIService.AdminGetioneInviaSpesa(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        context.dispatch('getNote');
                        $that.$notify({
                            group: res.stato,
                            text: res.textError
                          });
                    })
        },
        getMensile(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'Estrazione...'});
            APIService.reportAdminGetMensile(params)
                    .then(function (res) {
                      if (res.stato === 'success') {
                        context.commit('SET_REPORT_MENSILE', res.data)
                      }
                      context.commit('SET_LOADING', {state: false});
                    })
        },
        getPreautorizzati(context, params) {
//            context.commit('SET_LOADING', {state: true, text: 'Estrazione...'});
            APIService.getPreautorizzati()
                    .then(function (res) {
                      if (res.stato === 'success') {
                       
                        context.commit('SET_PREAUTORIZZATI', res.data.preautorizzati)
                      }
//                      context.commit('SET_LOADING', {state: false});
                    })
        },
        getRichieste(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'Estrazione...'});
            APIService.getRichieste()
                    .then(function (res) {
                      if (res.stato === 'success') {
                       
                        context.commit('SET_RICHIESTE', res.data.richieste)
                      }
                      context.commit('SET_LOADING', {state: false});
                    })
        },
        salvaPreautorizzato(context, params) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'Sta inviando ...'});
            return APIService.salvaPreautorizzato(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        context.dispatch('getPreautorizzati');
                        $that.$notify({
                            group: res.stato,
                            text: res.textError
                          });
                    })
        },
        confermaAutorizzazione(context, params) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'Sta inviando ...'});
            return APIService.confermaAutorizzazione(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        context.dispatch('getRichieste');
                        $that.$notify({
                            group: res.stato,
                            text: res.textError
                          });
                    })
        },
        eliminaAutorizzazione(context, params) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'Sta inviando ...'});
            return APIService.eliminaAutorizzazione(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        context.dispatch('getRichieste');
                        $that.$notify({
                            group: res.stato,
                            text: res.textError
                          });
                    })
        },
        eliminaPreautorizzato(context, params) {
            let $that = this._vm;
            
            context.commit('SET_LOADING', {state: true, text: 'Sta inviando ...'});
            return APIService.eliminaPreautorizzato(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        context.dispatch('getPreautorizzati');
                        $that.$notify({
                            group: res.stato,
                            text: res.textError
                          });
                    })
        },
    }
};

export default pageStore;


// WEBPACK FOOTER //
// ./modules/Home/views/src/stores/gestioneAdmin.js